import { HELPER_READ_ONLY_DETAIL } from "./helperThread.ts";
import { REACTION_IS_NOT_A_MESSAGE } from "./messageReactions.ts";
import { BRING_BACK_NOTHING_NEW_SENTENCE } from "./orchestration.ts";

/**
 * W-d0329709: the decider's refusals written for people. Only these reach a
 * person as the reason a message was not sent; any other refusal (an archived
 * or missing conversation, a storage or admission failure) names ids and
 * command types, and the person reads a neutral line instead. A sentence is
 * added here only as an exported constant the decider itself refuses with.
 */
export const PERSON_FACING_COMMAND_REFUSALS: ReadonlySet<string> = new Set([
  BRING_BACK_NOTHING_NEW_SENTENCE,
  HELPER_READ_ONLY_DETAIL,
  REACTION_IS_NOT_A_MESSAGE,
]);

/** A refusal's detail when it is one of the sentences written for people; otherwise undefined. */
export function personFacingCommandRefusal(detail: unknown): string | undefined {
  if (typeof detail !== "string") return undefined;
  const sentence = detail.trim();
  return PERSON_FACING_COMMAND_REFUSALS.has(sentence) ? sentence : undefined;
}
